module.exports = __webpack_public_path__ + "static/00049.5f16bda4.jpg";